<template>
  <div style="width: 100%" class="mapBox">
    <div id="map_canva"></div>
    <div class="mapBtn">
      <el-row class="mapRow">
        <el-col :span="13">
          <el-slider
            style="margin: 5px 5px 0 0"
            v-model="carSpeed"
            :min="50"
            :max="200"
            @change="changeSlider"
            :step="50"
            :marks="marks"
            :show-tooltip="false"
            show-stops
          ></el-slider>
        </el-col>
        <el-col style="line-height: 50px" :span="11">
          <el-button size="small" @click="run" type="primary"
            >开始回放</el-button
          >
          <el-button
            size="small"
            v-if="!btnStatus"
            @click="Continue"
            type="success"
            >继续回放</el-button
          >
          <el-button size="small" v-if="btnStatus" @click="pause" type="success"
            >暂停回放</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="mapTime">
      <el-date-picker
        size="mini"
        v-model="DataValue"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
:range-separator="$t('common.to')"
     :start-placeholder="$t('common.starDate')"
     :end-placeholder="$t('common.endDate')"
      ></el-date-picker>
      <el-button
        :loading="searchSpin"
        style="margin-left: 20px"
        @click="queryMove"
        size="mini"
        type="primary"
        >{{$t('common.btn.search')}}
      </el-button>
    </div>
  </div>
</template>
<script>
import car from "../assets/images/car.png";
export default {
  data() {
    return {
      ak: "Fvp7gN1wU8IxfdUTa0Vpieci6dLZbpe7",
      map: null,
      carOptions: [],
      centerPoint: null,
      DataValue: [],
      searchSpin: false,
      carSpeed: 50,
      marks: {
        5: "",
        53: "x1",
        100: "x2",
        150: "x4",
        200: "x8",
      },
      btnStatus: true,
      carOptions: [],
      tweenPoint: [],
      polyline: null,
      carLabel: null,
      arr: [],
      carData: [],
      marker: null,
      pausePath: [],
      thatMap: null,
      lushu: null,
      carId: '',
      name: ''
    };
  },
  props: ["bindTerminal"],
  created() {
    this.getData();
  },
  mounted() {
    this.map = new window.BMapGL.Map("map_canva");
    this.map.setMapStyleV2({
      styleId: "",
    });
    this.map.centerAndZoom(
      new window.BMapGL.Point(117.36132040488154, 31.787080848768532),
      10
    ); 
    this.map.addControl(
      new window.BMapGL.MapTypeControl({
        mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP],
      })
    );
    this.map.enableScrollWheelZoom(true);
  },
  methods: {
    getData() {
      const endTime = this.$formatTime(new Date());
      const startTime = this.$formatTime(this.$moment().subtract(2, "hour").toDate());
      this.DataValue = [startTime, endTime];
    },
    getRealTime() {
      const startTime = this.DataValue[0] ? 
        this.$moment.tz(this.DataValue[0], 'YYYY-MM-DD HH:mm:ss', 'Asia/Shanghai').format('YYYY-MM-DD HH:mm:ss') : '';
      const endTime = this.DataValue[1] ? 
        this.$moment.tz(this.DataValue[1], 'YYYY-MM-DD HH:mm:ss', 'Asia/Shanghai').format('YYYY-MM-DD HH:mm:ss') : '';
      let param = {
        terminalIds: this.bindTerminal,
        startTime: startTime,
        endTime: endTime,
      };
      this.$store
        .dispatch("VehicleFiles/GET_CARTRAJECTORY", param)
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              this.carOptions = res.data.data;
              res.data.data.map((item, index) => {
                this.carData = item.data;
                this.carId = item.carId
                this.name = item.name
              });
              this.initMap();
            } else {
              this.$message.error(res.data.msg);
            }
          }
        })
        .catch((err) => {});
    },

    initPolyline() {
      return new window.BMapGL.Polyline([], {
        strokeColor: "#5f77fd",
        strokeWeight: 2,
        strokeOpacity: 1,
      });
    },

    initLabel() {
      const label = new window.BMapGL.Label("", {
        offset: new window.BMapGL.Size(0, 30),
      });
      label.setStyle({
        border: "1px solid rgb(204, 204, 204)",
        color: "rgb(0, 0, 0)",
        borderRadius: "10px",
        padding: "5px",
        backgroundColor: "rgb(255, 255, 255)",
      });

      return label;
    },

    initMap() {
      let t = this;
      let arrPois = [];

      this.tweenPoint = [];
      this.polyline = this.initPolyline()
      this.carLabel = this.initLabel()

      this.carData.map((items) => {
        arrPois.push(new BMapGL.Point(items.lng, items.lat));
      });
      this.arr = arrPois;

      this.map.setViewport(arrPois);
      this.marker = new window.BMapGL.Marker(arrPois[0], {
        icon: new window.BMapGL.Icon(car, new window.BMapGL.Size(56, 28), {}),
      });

      this.marker.setLabel(this.carLabel);
      window.BMapGLLib.LuShu.prototype._move = function (
        initPos,
        targetPos,
        effect
      ) {
        t.thatMap = this;
        let me = this;
        let pointsArr = [initPos, targetPos];
        let currentCount = 0;
        let timer = 10;
        let step = this._opts.speed / (1000 / timer);
        let init_pos = window.BMapGL.Projection.convertLL2MC(initPos);
        let target_pos = window.BMapGL.Projection.convertLL2MC(targetPos);
        init_pos = new window.BMapGL.Pixel(init_pos.lng, init_pos.lat);
        target_pos = new window.BMapGL.Pixel(target_pos.lng, target_pos.lat);
        let count = Math.round(me._getDistance(init_pos, target_pos) / step);

        t.pausePath = pointsArr;

        if (count < 1) {
          me._moveNext(++me.i);
          return;
        }

        this._map.addOverlay(t.polyline);
        this._map.addOverlay(t.marker);
        this._map.addOverlay(t.carLabel);
        console.log(111)

        me._intervalFlag = setInterval(function () {
          if (currentCount >= count) {
            t.km = Math.ceil(Math.random() * 4 + 1);

            clearInterval(me._intervalFlag);
            if (me.i > me._path.length) {
              return;
            }
            me._moveNext(++me.i);
          } else {
            currentCount++;
            var x = effect(init_pos.x, target_pos.x, currentCount, count),
              y = effect(init_pos.y, target_pos.y, currentCount, count),
              pos = window.BMapGL.Projection.convertMC2LL(
                new window.BMapGL.Point(x, y)
              );
            if (currentCount == 1) {
              var proPos = null;
              if (me.i - 1 >= 0) {
                proPos = me._path[me.i - 1];
              }
              if (me._opts.enableRotation == true) {
                me.setRotation(proPos, initPos, targetPos);
              }
              if (me._opts.autoView) {
                if (!me._map.getBounds().containsPoint(pos)) {
                  me._map.setCenter(pos);
                }
              }
            }
            let catWord = "";
            t.carData.map((p, k) => {
              if (p.lng == targetPos.lng && p.lat == targetPos.lat) {
                catWord = `车辆编号:${t.carId}<br/>终端编号:${t.name}<br/>时间:${t.$formatTime(p.dateTime)}`;
              }
            });

            t.tweenPoint.push(pos);
            t.polyline.setPath(t.tweenPoint);

            me._marker.setPosition(pos);
            me._marker.setLabel(t.carLabel);

            t.carLabel.setContent(catWord);
          }
        }, timer);
      };
      this.lushu = new window.BMapGLLib.LuShu(this.map, arrPois, {
        defaultContent: "",
        autoView: true, 
        icon: new window.BMapGL.Icon(car, new window.BMapGL.Size(56, 28), {}),
        speed: this.carSpeed,
        enableRotation: true, 
        landmarkPois: [],
      });
      this.lushu.start();
    },
    queryMove() {
      this.getRealTime();
    },
    changeSlider(value) {
        if (value) {
        value = window.sessionStorage.getItem('current_speed') ? parseInt(window.sessionStorage.getItem('current_speed')) : 50
      }
      window.sessionStorage.setItem('current_speed', value)
      if (this.carData.length == 0) {
        this.$message.error('当前时间段没有运动轨迹')
      } else {
        if (this.btnStatus) {
          if (value === 150) {
            this.lushu._opts.speed = 400
            this.lushu.start()
            return
          } else if (value === 200) {
            this.lushu._opts.speed = 800
            this.lushu.start()
            return
          }

          this.lushu._opts.speed = this.carSpeed * 2
          this.lushu.start()
        } else {
          if (value === 150) {
            this.lushu._opts.speed = 400
            this.lushu.start()
            return
          } else if (value === 200) {
            this.lushu._opts.speed = 800
            this.lushu.start()
            return
          }

          this.lushu._opts.speed = this.carSpeed * 2
        }
      }
    },
    run() {
      this.map.clearOverlays();
      this.tweenPoint = [];
      if (this.lushu) {
        this.lushu.pause();
        this.lushu.stop();
      }

      if (this.carData.length == 0) {
        this.$message.error("当前时间段没有运动轨迹");
      } else {
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          this.lushu.start();
          this.changeSlider();
          this.btnStatus = true;
        }, 700);
      }
    },
    Continue() {
        if (this.carData.length == 0) {
        this.$message.error('当前时间段没有运动轨迹')
      } else {
        this.btnStatus = true
        this.thatMap._map.addOverlay(
          new BMap.Polyline(this.carData, {
            strokeColor: '#5f77fd',
            strokeWeight: 2,
            strokeOpacity: 1,
          })
        )
        this.marker.enableMassClear()
        this.marker.hide()
        this.lushu.start()
      }
    },
    pause() {
        if (this.carData.length == 0) {
        this.$message.error('当前时间段没有运动轨迹')
      } else {
        this.btnStatus = false
        this.lushu.pause()
      }
    },
  },
  beforeDestroy() {
    this.map.clearOverlays();
    this.tweenPoint = [];
    if (this.lushu) {
      this.lushu.pause();
      this.lushu.stop();
    }
  },
};
</script>
<style>
#map_canva {
  width: 100%;
  height: 700px;
}

.mapBox {
  position: relative;
}

.mapTime {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 9999;
}

.el-range-editor--mini .el-range-input,
.el-range-editor--mini .el-range-separator {
  font-size: 14px;
}

.mapRow .el-slider__marks-text {
  width: 20px;
  margin-top: 10px;
}

.mapBtn {
  position: absolute;
  bottom: 10px;
  text-align: center;
  left: 50%;
  margin-left: -190px;
  z-index: 9999;
}

.mapRow {
  width: 420px;
  margin: 0px auto;
  background-color: white;
  height: 50px;
  padding: 0 10px 0 20px;
}
</style>
